import $ from 'jquery';
window.$ = window.jQuery = $;
import { default as Common } from './modules/common.js';
import { default as Collapse } from './modules/collapse.js';
import { default as Forms } from './modules/forms.js';
import { default as Locations } from './modules/locations.js';
import { default as Modals } from './modules/modals.js';
import { default as Sliders } from './modules/sliders.js';
import { default as Tabs } from './modules/tabs.js';
import { default as Tour } from './modules/tour.js';
import { default as Track } from './modules/track.js';

const modules = {
  Common,
  Collapse,
  Forms,
  Locations,
  Modals,
  Sliders,
  Tabs,
  Tour,
  Track
};

Object.keys(modules).forEach(key => {
  modules[key].init();
  window[key] = modules[key];
});
